import { apiClient } from './client';
import type { User } from '../types';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const authApi = {
  // Get current user
  getCurrentUser: async (): Promise<User> => {
    const { data } = await apiClient.get<User>('/auth/me');
    return data;
  },

  // Logout
  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout');
  },

  // Get Discord OAuth URL
  getDiscordAuthUrl: (): string => {
    return `${API_BASE_URL}/api/auth/discord`;
  },
};
